import { ASSETS_BUCKET, SERVE_BUCKET, STORAGE_ORIGIN_URL } from './env';

/**
 * Resolves a filename to an absolute URL.
 * @callback AbsoluteUrlResolver
 * @param {string} filename The name of the file to resolve.
 * @returns {string} The absolute URL of the file.
 */
export type AbsoluteUrlResolver = (filename: string) => string;

/**
 * Resolves a filename to an absolute URL for the assets bucket.
 * @type {AbsoluteUrlResolver}
 */
export const assets: AbsoluteUrlResolver = (filename: string) => {
  const fileName = filename.startsWith('/') ? filename.slice(1) : filename;
  return `${STORAGE_ORIGIN_URL}/${ASSETS_BUCKET}/${fileName}`;
};

/**
 * Resolves a filename to an absolute URL for the serve bucket.
 * @type {AbsoluteUrlResolver}
 */
export const serve: AbsoluteUrlResolver = filename => {
  const fileName = filename.startsWith('/') ? filename.slice(1) : filename;
  return `${STORAGE_ORIGIN_URL}/${SERVE_BUCKET}/${fileName}`;
};
